import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/formatting';

const textVariants = cva('', {
  variants: {
    variant: {
      body: 'text-base leading-normal',
      'body-sm': 'text-sm leading-normal',
      caption: 'text-xs leading-normal',
      label: 'text-sm font-medium',
      overline: 'text-xs font-semibold uppercase tracking-wider',
      stat: 'text-2xl md:text-3xl font-extrabold tracking-tight leading-none',
    },
    color: {
      primary: 'text-text-primary',
      secondary: 'text-text-secondary',
      muted: 'text-text-muted',
      tertiary: 'text-text-tertiary',
      accent: 'text-red-primary',
      error: 'text-error',
      success: 'text-success',
    },
  },
  defaultVariants: {
    variant: 'body-sm',
    color: 'secondary',
  },
});

type TextElement = 'p' | 'span' | 'div' | 'label' | 'small';

type TextProps = Omit<React.HTMLAttributes<HTMLElement>, 'color'> &
  VariantProps<typeof textVariants> & {
    as?: TextElement;
  };

function Text({ className, variant, color, as: Tag = 'p', ...props }: TextProps) {
  return (
    <Tag data-slot="text" className={cn(textVariants({ variant, color, className }))} {...props} />
  );
}

export { Text, textVariants, type TextProps };
